import React from 'react'

// import './InfoBox.css';
import { formatPriceWithTwoDecimals } from '@/core/utils/numbers'

interface TourInfoBoxProps {
  time: string
  distance: string
  old_price?: number
  discount?: boolean
  price?: string | number
}

const TourInfoBox: React.FC<TourInfoBoxProps> = ({ time, distance, price = '', old_price, discount }) => {
  function formatOldPrice(price: number): string {
    return formatPriceWithTwoDecimals(price)
  }

  function renderPrice(price?: string | number, old_price?: number) {
    const formattedPrice =
      price !== undefined && price !== '' ? formatPriceWithTwoDecimals(price) : ''

    if (!discount) {
      return <div className="info-box price">€{formattedPrice}</div>
    }

    const formattedOldPrice = old_price !== undefined ? formatOldPrice(old_price) : ''

    return (
      <div className="info-box price-box">
        <span className="old-price-wrapper">
          <span className="old-price">€{formattedOldPrice}</span>
          <span className="old-price-chevron">{'>'}</span>
        </span>
        <span className="new-price">€{formattedPrice}</span>
      </div>
    )
  }

  return (
    <div className="info-container">
      <div className="info-box">{time} hour</div>
      <div className="info-box">{distance}km</div>
      {renderPrice(price, old_price)}
    </div>
  )
}

export default TourInfoBox
